import { QUESTION_TYPE } from './Question';

export const questionItems = [
    {
        key: QUESTION_TYPE.SHORT,
        label: 'คำตอบแบบสั้น',
        icon: (
            <svg
                width="16"
                height="4"
                viewBox="0 0 16 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M0 0H16V1H0V0ZM0 4V3H16V4H0Z" fill="#65707A" />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.LONG,
        label: 'คำตอบแบบยาว',
        icon: (
            <svg
                width="16"
                height="13"
                viewBox="0 0 16 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16 0V1H0V0H16ZM0 12H16V13H0V12ZM0 6H16V7H0V6ZM0 3H16V4H0V3ZM0 9H16V10H0V9Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.RADIO,
        label: 'แบบตัวเลือก ตอบได้คำตอบเดียว',
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8 0C8.73438 0 9.44271 0.09375 10.125 0.28125C10.8073 0.46875 11.4453 0.736979 12.0391 1.08594C12.6328 1.4349 13.1719 1.85156 13.6562 2.33594C14.1406 2.82031 14.5573 3.36198 14.9062 3.96094C15.2552 4.5599 15.5234 5.19792 15.7109 5.875C15.8984 6.55208 15.9948 7.26042 16 8C16 8.73438 15.9062 9.44271 15.7188 10.125C15.5312 10.8073 15.263 11.4453 14.9141 12.0391C14.5651 12.6328 14.1484 13.1719 13.6641 13.6562C13.1797 14.1406 12.638 14.5573 12.0391 14.9062C11.4401 15.2552 10.8021 15.5234 10.125 15.7109C9.44792 15.8984 8.73958 15.9948 8 16C7.26562 16 6.55729 15.9062 5.875 15.7188C5.19271 15.5312 4.55469 15.263 3.96094 14.9141C3.36719 14.5651 2.82812 14.1484 2.34375 13.6641C1.85938 13.1797 1.44271 12.638 1.09375 12.0391C0.744792 11.4401 0.476562 10.8047 0.289062 10.1328C0.101562 9.46094 0.00520833 8.75 0 8C0 7.26562 0.09375 6.55729 0.28125 5.875C0.46875 5.19271 0.736979 4.55469 1.08594 3.96094C1.4349 3.36719 1.85156 2.82812 2.33594 2.34375C2.82031 1.85938 3.36198 1.44271 3.96094 1.09375C4.5599 0.744792 5.19531 0.476562 5.86719 0.289062C6.53906 0.101562 7.25 0.00520833 8 0ZM8 15C8.64062 15 9.25781 14.9167 9.85156 14.75C10.4453 14.5833 11.0026 14.349 11.5234 14.0469C12.0443 13.7448 12.5182 13.3776 12.9453 12.9453C13.3724 12.513 13.737 12.0417 14.0391 11.5312C14.3411 11.0208 14.5781 10.4635 14.75 9.85938C14.9219 9.25521 15.0052 8.63542 15 8C15 7.35938 14.9167 6.74219 14.75 6.14844C14.5833 5.55469 14.349 4.9974 14.0469 4.47656C13.7448 3.95573 13.3776 3.48177 12.9453 3.05469C12.513 2.6276 12.0417 2.26302 11.5312 1.96094C11.0208 1.65885 10.4635 1.42188 9.85938 1.25C9.25521 1.07812 8.63542 0.994792 8 1C7.35938 1 6.74219 1.08333 6.14844 1.25C5.55469 1.41667 4.9974 1.65104 4.47656 1.95312C3.95573 2.25521 3.48177 2.6224 3.05469 3.05469C2.6276 3.48698 2.26302 3.95833 1.96094 4.46875C1.65885 4.97917 1.42188 5.53646 1.25 6.14062C1.07812 6.74479 0.994792 7.36458 1 8C1 8.64062 1.08333 9.25781 1.25 9.85156C1.41667 10.4453 1.65104 11.0026 1.95312 11.5234C2.25521 12.0443 2.6224 12.5182 3.05469 12.9453C3.48698 13.3724 3.95833 13.737 4.46875 14.0391C4.97917 14.3411 5.53646 14.5781 6.14062 14.75C6.74479 14.9219 7.36458 15.0052 8 15ZM8 2.75C8.48438 2.75 8.94792 2.8125 9.39062 2.9375C9.83333 3.0625 10.2526 3.23958 10.6484 3.46875C11.0443 3.69792 11.3984 3.97135 11.7109 4.28906C12.0234 4.60677 12.2969 4.96094 12.5312 5.35156C12.7656 5.74219 12.9427 6.15885 13.0625 6.60156C13.1823 7.04427 13.2448 7.51042 13.25 8C13.25 8.48438 13.1875 8.94792 13.0625 9.39062C12.9375 9.83333 12.7604 10.2526 12.5312 10.6484C12.3021 11.0443 12.0286 11.3984 11.7109 11.7109C11.3932 12.0234 11.0391 12.2969 10.6484 12.5312C10.2578 12.7656 9.84115 12.9427 9.39844 13.0625C8.95573 13.1823 8.48958 13.2448 8 13.25C7.51562 13.25 7.05208 13.1875 6.60938 13.0625C6.16667 12.9375 5.7474 12.7604 5.35156 12.5312C4.95573 12.3021 4.60156 12.0286 4.28906 11.7109C3.97656 11.3932 3.70312 11.0391 3.46875 10.6484C3.23438 10.2578 3.05729 9.84115 2.9375 9.39844C2.81771 8.95573 2.75521 8.48958 2.75 8C2.75 7.51562 2.8125 7.05208 2.9375 6.60938C3.0625 6.16667 3.23958 5.7474 3.46875 5.35156C3.69792 4.95573 3.97135 4.60156 4.28906 4.28906C4.60677 3.97656 4.96094 3.70312 5.35156 3.46875C5.74219 3.23438 6.15885 3.05729 6.60156 2.9375C7.04427 2.81771 7.51042 2.75521 8 2.75Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.CHECKBOX,
        label: 'แบบตัวเลือก ตอบได้หลายคำตอบ',
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16 0V16H0V0H16ZM13.3516 5.35156L12.6484 4.64844L6 11.2891L3.35156 8.64844L2.64844 9.35156L6 12.7109L13.3516 5.35156Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.DATE_TIME,
        label: 'วันที่และเวลา',
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.3359 7.11719C13.7422 7.3099 14.1094 7.55208 14.4375 7.84375C14.7656 8.13542 15.0469 8.46615 15.2812 8.83594C15.5156 9.20573 15.6927 9.60156 15.8125 10.0234C15.9323 10.4453 15.9948 10.8828 16 11.3359C16 11.9766 15.8776 12.5807 15.6328 13.1484C15.388 13.7161 15.0547 14.2109 14.6328 14.6328C14.2109 15.0547 13.7161 15.388 13.1484 15.6328C12.5807 15.8776 11.9766 16 11.3359 16C10.8828 16 10.4453 15.9375 10.0234 15.8125C9.60156 15.6875 9.20833 15.5104 8.84375 15.2812C8.47917 15.0521 8.14844 14.7734 7.85156 14.4453C7.55469 14.1172 7.3099 13.7474 7.11719 13.3359H0V1.33594H2.66406V0H4V1.33594H9.33594V0H10.6641V1.33594H13.3359V7.11719ZM1.33594 4H12V2.66406H1.33594V4ZM6.71094 12C6.67969 11.7812 6.66406 11.5599 6.66406 11.3359C6.66406 10.6901 6.78646 10.0833 7.03125 9.51562C7.27604 8.94792 7.60938 8.45312 8.03125 8.03125C8.45312 7.60938 8.94792 7.27604 9.51562 7.03125C10.0833 6.78646 10.6901 6.66406 11.3359 6.66406C11.5599 6.66406 11.7812 6.67969 12 6.71094V5.33594H1.33594V12H6.71094ZM11.3359 14.6641C11.7943 14.6641 12.224 14.5781 12.625 14.4062C13.026 14.2344 13.3802 13.9948 13.6875 13.6875C13.9948 13.3802 14.2318 13.0286 14.3984 12.6328C14.5651 12.237 14.6536 11.8047 14.6641 11.3359C14.6641 10.8776 14.5781 10.4453 14.4062 10.0391C14.2344 9.63281 13.9974 9.27865 13.6953 8.97656C13.3932 8.67448 13.0391 8.4375 12.6328 8.26562C12.2266 8.09375 11.7943 8.00521 11.3359 8C10.8724 8 10.4401 8.08594 10.0391 8.25781C9.63802 8.42969 9.28385 8.66927 8.97656 8.97656C8.66927 9.28385 8.43229 9.63802 8.26562 10.0391C8.09896 10.4401 8.01042 10.8724 8 11.3359C8 11.7995 8.08594 12.2318 8.25781 12.6328C8.42969 13.0339 8.66927 13.3854 8.97656 13.6875C9.28385 13.9896 9.63802 14.2266 10.0391 14.3984C10.4401 14.5703 10.8724 14.6589 11.3359 14.6641ZM12 10.6641H13.3359V12H10.6641V9.33594H12V10.6641Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.DATE,
        label: 'วันที่',
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.5717 2.14509H11.5717V1.00223C11.5717 0.923661 11.5074 0.859375 11.4289 0.859375H10.4289C10.3503 0.859375 10.286 0.923661 10.286 1.00223V2.14509H5.71456V1.00223C5.71456 0.923661 5.65028 0.859375 5.57171 0.859375H4.57171C4.49314 0.859375 4.42885 0.923661 4.42885 1.00223V2.14509H1.42885C1.11278 2.14509 0.857422 2.40045 0.857422 2.71652V14.5737C0.857422 14.8897 1.11278 15.1451 1.42885 15.1451H14.5717C14.8878 15.1451 15.1431 14.8897 15.1431 14.5737V2.71652C15.1431 2.40045 14.8878 2.14509 14.5717 2.14509ZM13.8574 13.8594H2.14314V7.07366H13.8574V13.8594ZM2.14314 5.85938V3.4308H4.42885V4.28795C4.42885 4.36652 4.49314 4.4308 4.57171 4.4308H5.57171C5.65028 4.4308 5.71456 4.36652 5.71456 4.28795V3.4308H10.286V4.28795C10.286 4.36652 10.3503 4.4308 10.4289 4.4308H11.4289C11.5074 4.4308 11.5717 4.36652 11.5717 4.28795V3.4308H13.8574V5.85938H2.14314Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.UPLOAD,
        label: 'อัปโหลดไฟล์',
        icon: (
            <svg
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10 0V1H1V0H10ZM10.3516 7.64844L9.64844 8.35156L6 4.67969V16H5V4.67969L1.35156 8.35156L0.648438 7.64844L5.5 2.75781L10.3516 7.64844Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.TOPIC,
        label: 'หัวข้อและรายละเอียด',
        icon: (
            <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16 0V5H0V0H16ZM15 1H1V4H15V1ZM0 6H16V11H0V6ZM1 10H15V7H1V10ZM12 3H2V2H12V3ZM2 8H7V9H2V8Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
    {
        key: QUESTION_TYPE.OTP,
        label: 'OTP อีเมล',
        icon: (
            <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 0H16V11H0V0ZM15 10V1H1V10H15ZM4 6.75C3.82812 6.75 3.66667 6.71875 3.51562 6.65625C3.36458 6.59375 3.23177 6.5026 3.11719 6.38281C3.0026 6.26302 2.91406 6.13021 2.85156 5.98438C2.78906 5.83854 2.75521 5.67708 2.75 5.5C2.75 5.32812 2.78125 5.16667 2.84375 5.01562C2.90625 4.86458 2.9974 4.73177 3.11719 4.61719C3.23698 4.5026 3.36979 4.41406 3.51562 4.35156C3.66146 4.28906 3.82292 4.25521 4 4.25C4.17188 4.25 4.33333 4.28125 4.48438 4.34375C4.63542 4.40625 4.76823 4.4974 4.88281 4.61719C4.9974 4.73698 5.08594 4.86979 5.14844 5.01562C5.21094 5.16146 5.24479 5.32292 5.25 5.5C5.25 5.67188 5.21875 5.83333 5.15625 5.98438C5.09375 6.13542 5.0026 6.26823 4.88281 6.38281C4.76302 6.4974 4.63021 6.58594 4.48438 6.64844C4.33854 6.71094 4.17708 6.74479 4 6.75ZM8 6.75C7.82812 6.75 7.66667 6.71875 7.51562 6.65625C7.36458 6.59375 7.23177 6.5026 7.11719 6.38281C7.0026 6.26302 6.91406 6.13021 6.85156 5.98438C6.78906 5.83854 6.75521 5.67708 6.75 5.5C6.75 5.32812 6.78125 5.16667 6.84375 5.01562C6.90625 4.86458 6.9974 4.73177 7.11719 4.61719C7.23698 4.5026 7.36979 4.41406 7.51562 4.35156C7.66146 4.28906 7.82292 4.25521 8 4.25C8.17188 4.25 8.33333 4.28125 8.48438 4.34375C8.63542 4.40625 8.76823 4.4974 8.88281 4.61719C8.9974 4.73698 9.08594 4.86979 9.14844 5.01562C9.21094 5.16146 9.24479 5.32292 9.25 5.5C9.25 5.67188 9.21875 5.83333 9.15625 5.98438C9.09375 6.13542 9.0026 6.26823 8.88281 6.38281C8.76302 6.4974 8.63021 6.58594 8.48438 6.64844C8.33854 6.71094 8.17708 6.74479 8 6.75ZM12 6.75C11.8281 6.75 11.6667 6.71875 11.5156 6.65625C11.3646 6.59375 11.2318 6.5026 11.1172 6.38281C11.0026 6.26302 10.9141 6.13021 10.8516 5.98438C10.7891 5.83854 10.7552 5.67708 10.75 5.5C10.75 5.32812 10.7812 5.16667 10.8438 5.01562C10.9062 4.86458 10.9974 4.73177 11.1172 4.61719C11.237 4.5026 11.3698 4.41406 11.5156 4.35156C11.6615 4.28906 11.8229 4.25521 12 4.25C12.1719 4.25 12.3333 4.28125 12.4844 4.34375C12.6354 4.40625 12.7682 4.4974 12.8828 4.61719C12.9974 4.73698 13.0859 4.86979 13.1484 5.01562C13.2109 5.16146 13.2448 5.32292 13.25 5.5C13.25 5.67188 13.2188 5.83333 13.1562 5.98438C13.0938 6.13542 13.0026 6.26823 12.8828 6.38281C12.763 6.4974 12.6302 6.58594 12.4844 6.64844C12.3385 6.71094 12.1771 6.74479 12 6.75Z"
                    fill="#65707A"
                />
            </svg>
        ),
    },
];
